@if (device$ | async; as device) {
    <div class="emma-card__header">
        @if (!contextService.isKioskModeEnabled) {
            <a [routerLink]="'/device/' + device.id">{{ device.deviceName }}</a>
        }
        @if (contextService.isKioskModeEnabled) {
            <span>{{ device.deviceName }}</span>
        }
        - {{ title }}
    </div>

    @if (hasAnyData) {
        <div class="emma-card__content">
            <div
                class="custom-widget-card__body"
                [ngClass]="{
                    'custom-widget-card__body--chart': shouldShowChart,
                    'custom-widget-card__body--no-chart': !shouldShowChart,
                }"
            >
                @if (latestPrimaryTimestamp) {
                    <div class="custom-widget-card__timestamp">
                        <small>
                            {{ latestPrimaryTimestamp | date: "MMM d, y, h:mm:ss a" }}
                        </small>
                    </div>
                }
                <div
                    class="custom-widget-card__primary"
                    [ngClass]="{ 'custom-widget-card__primary--no-chart': !shouldShowChart }"
                >
                    @for (metric of primaryMetrics; track metric.key) {
                        <div class="custom-widget-card__primary-item">
                            <h2
                                class="custom-widget-card__primary-value"
                                [ngClass]="{
                                    'orange-fg': metric.status === 'warning',
                                    'red-fg': metric.status === 'alarm',
                                }"
                            >
                                {{ metric.value }}
                            </h2>
                            <small class="custom-widget-card__primary-label">
                                {{ "FIELD." + metric.key | translate }}
                            </small>
                        </div>
                    }
                </div>

                @if (secondaryMetrics.length > 0) {
                    <div
                        class="custom-widget-card__secondary"
                        [ngClass]="{ 'custom-widget-card__secondary--no-chart': !shouldShowChart }"
                    >
                        @for (metric of secondaryMetrics; track metric.key) {
                            <div class="custom-widget-card__secondary-item">
                                <strong
                                    class="custom-widget-card__secondary-value"
                                    [ngClass]="{
                                        'orange-fg': metric.status === 'warning',
                                        'red-fg': metric.status === 'alarm',
                                    }"
                                >
                                    {{ metric.value }}
                                </strong>
                                {{ "FIELD." + metric.key | translate }}
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }

    @if (!hasAnyData) {
        <div class="emma-card__content emma-card__content--center">
            <small>No data yet</small>
            <div>
                <b>Widget data unavailable</b>
            </div>
        </div>
    }

    @if (shouldShowChart) {
        <div class="emma-card__footer-full-width custom-widget-card__chart">
            <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chart.constructor"
                [options]="chart.options"
                [(update)]="chart.update"
                [callbackFunction]="chartCallback"
                style="width: 100%; display: block"
            ></highcharts-chart>
        </div>
    }

    @if (!device.connected && hasAnyData) {
        <div class="emma-card__offline">Device offline</div>
    }
}
